// Drop this near the end of theme.liquid before </body>, or in a global JS with "defer"
(function () {
  // Set to true if you want to hide (display:none !important) instead of removing the HTML
  const HIDE_INSTEAD_OF_REMOVE = false;

  // Normalize and match helper
  function looksEmpty(text) {
    if (!text) return false;
    // normalize spaces, strip punctuation, and compare case-insensitively
    const norm = text.replace(/\s+/g, ' ')
                     .replace(/[^\w\s]/g, '')
                     .trim()
                     .toLowerCase();
    return norm.includes('be the first to write a review');
  }

  function handleNode(root) {
    const nodes = root.querySelectorAll
      ? root.querySelectorAll('.jdgm-rev-widg__summary-text')
      : [];

    nodes.forEach((summary) => {
      const txt = summary.textContent || summary.innerText || '';
      if (!looksEmpty(txt)) return;

      // Find the nearest ancestor with the (non-unique) ID judgeme_product_reviews
      const container = summary.closest('#judgeme_product_reviews');
      if (!container) return;

      // Remove or hide, per your preference
      if (HIDE_INSTEAD_OF_REMOVE) {
        container.style.setProperty('display', 'none', 'important');
      } else {
        container.remove();
      }
    });
  }

  // Run now (covers SSR/inlined widgets)
  handleNode(document);

  // Also run on DOMContentLoaded & window load (covers many themes)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => handleNode(document));
  } else {
    handleNode(document);
  }
  window.addEventListener('load', () => handleNode(document));

  // MutationObserver to catch Judge.me injecting after load
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type !== 'childList') continue;
      m.addedNodes.forEach((n) => {
        if (n.nodeType !== 1) return; // element nodes only
        // If the added node IS a summary text or contains one, process that subtree
        if (n.matches && n.matches('.jdgm-rev-widg__summary-text')) {
          handleNode(n.parentNode || document);
        } else if (n.querySelector && n.querySelector('.jdgm-rev-widg__summary-text')) {
          handleNode(n);
        }
      });
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
